// frontend/src/services/adminService.js
import apiClient from './apiClient';

const getLogs = () => {
    return apiClient.get('/admin/logs');
};

export const adminService = {
    getLogs,
};
